import { render } from "./QuizContent.vue?vue&type=template&id=b5ffdd6e&scoped=true"
import script from "./QuizContent.vue?vue&type=script&lang=js"
export * from "./QuizContent.vue?vue&type=script&lang=js"

import "./QuizContent.vue?vue&type=style&index=0&id=b5ffdd6e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ffdd6e"]])

export default __exports__